import { FC } from "react";

import { Button } from "antd";

const GenerateTransactionPdf: FC<{ ids: string[] }> = ({ ids }) => {
  return (
    <Button
      disabled={ids.length === 0}
      style={{ backgroundColor: "#ef5350" }}
      onClick={async () => {
        window.open(
          `https://melcarnebackend.digipulse.ch/generate_export_pdf?transactionsIds=` +
            JSON.stringify(ids)
        );
      }}
    >
      {`Générer PDF${ids.length > 0 ? ` (${ids.length})` : ""}`}
    </Button>
  );
};

export default GenerateTransactionPdf;
